export const validatedZip = (zip) => {
  if (isNaN(zip) && zip !== "") {
    return null;
  } else if (zip.toString().length > 10) {
    return zip.toString().slice(0, 10);
  } else {
    return zip.toString();
  }
};
